import loggedReducer from './isLogged';
import { combineReducers } from 'redux';
import searchBarReducer from './seachBar';
import menuReducer from './menu';
import settingsReducer from './settings';
import notificationCenterReducer from './notificationCenter';
import businessRoundsReducer from './businessRoundsReducer';

const allReducers = combineReducers({
    menu: menuReducer,
    settings: settingsReducer,
    searchBar: searchBarReducer,
    notificationCenter: notificationCenterReducer,
    businessRoundsReducer
})

export default allReducers;
